<template>
  <main>
    <h2 class="ttl"><img src="/img/ico_job.png" alt="仕事を探す" width="40" class="mb30"><br>{{$t('findJob')}}</h2>
    <div class="account-box mb30">
      <p class="txt-mini pl15">{{$t('japaneseLevel')}}</p>
      <p class="txt-selectbox">
        <select name="level" v-model="langLevel" @change="filter">
          <option value="">{{$t('all')}}</option>
          <option v-for="langLevel in langLevels" :key="langLevel.code" :value="langLevel.code">
            {{ langLevel.level }}
          </option> 
        </select>
      </p>
      <p class="txt-mini pl15">{{$t('workLocation')}}</p>
      <p class="txt-selectbox">
        <select name="pref" v-model="workPlace" @change="filter">
          <option value="">{{$t('all')}}</option>
          <option v-for="pref in prefs" :key="pref.code" :value="pref.code">
            {{ pref.name + ' - ' + pref.name_r }}
          </option>
        </select>
      </p>
    </div>
    <div v-if="jobs.length > 0" class="job-area">
      <div class="job-box" v-for="(job , index) in jobs" :key="index">
        <router-link :to="{ name: 'Job' , params: { id: job.id } }">
          <p>{{ job.prefInfo.name }} - {{ job.prefInfo.name_r }}</p>
          <p class="job-ttl">{{ job.summary }}</p>
          <dl>
            <dt>{{$t('hourlyWage')}}</dt>
            <dd v-if="job.salaryFrom">
              <span>&yen;{{ (job.salaryFrom).toLocaleString() }}</span>
              <span v-if="job.salaryTo"> 〜 &yen;{{ (job.salaryTo).toLocaleString() }}</span>
            </dd>
            <dt>{{$t('japaneseLevel')}}</dt>
            <dd>{{ job.japlabel.level }}</dd>
          </dl>
        </router-link>
      </div>
      <span class="morelink link1" @click="load" :hidden="hideMore">さらに読み込む</span>
    </div>
    <p v-if="isEmptyJobs" class="center mt80 mb80">
      {{$t('noJob')}}
    </p>
  </main >
</template>

<script>
import firebase from 'firebase'
import prefs from '@/constants/PrefsEnum'
import langLevels from '@/constants/langLevelsEnum'

export default {
  name: 'Jobs',
  mixins: [ 
    langLevels,
    prefs
  ],
  data () {
    return {
      db: firebase.firestore(),
      jobs: [],
      isEmptyJobs: false,
      workPlace: "",
      langLevel: "",
      page: {
        current: null,
        limit: 10,
      },
      hideMore: true
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.isEmptyJobs = false
      var ref = this.db.collection("jobs").where("display_status", "==", 1)
      if (this.isNotEmpty(this.langLevel)) {
        ref = ref.where("japanese_level_code" , ">=" , this.langLevel)
      }
      if (this.isNotEmpty(this.workPlace)) {
        ref = ref.where("pref_code" , "==" , this.workPlace)
      }
      if (this.isNotEmpty(this.langLevel)) {
        ref = ref.orderBy('japanese_level_code', 'asc')
      }
      if (this.isEmpty(this.workPlace)) {
        ref = ref.orderBy("pref_code" , "asc")
      }
      ref = ref.orderBy('updated_at', 'desc')

      if (this.page.current) {
        ref = ref.startAfter(this.page.current)
      }
      try {
        const snapshot = await ref.limit(this.page.limit).get()
        this.page.current = snapshot.docs[snapshot.size - 1]
        this.hideMore = !this.page.current || snapshot.size < this.page.limit
        snapshot.forEach((doc) => {
          var data = doc.data()
          this.jobs.push({
            id: doc.id,
            summary: data.summary,
            prefInfo: this.prefs.find(e => e.code == data.pref_code),
            salaryFrom: data.salary_from,
            salaryTo: data.salary_to,
            japlabel: this.langLevels.find(e => e.code == data.japanese_level_code),
          })
        })
        this.isEmptyJobs = this.jobs.length == 0
      } catch {
        this.$toasted.error("データの取得に失敗しました")
      }
    },
    filter () {
      this.jobs = []
      this.page.current = null
      this.load()
    },
  },
}
</script>
